import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CategoryData, getExportingOptions } from '../utils/jsonDataProcessing';

interface CategoryTreemapProps {
  categoryData: CategoryData;
}

const CategoryTreemap: React.FC<CategoryTreemapProps> = ({ categoryData }) => {
  const categoryDistributionData = Object.entries(categoryData.categoryCounts).map(([name, count]) => ({
    name,
    value: count
  }));

  const options = {
    chart: {
      height: '400px'
    },
    title: {
      text: ''
    },
    series: [{
      type: 'treemap',
      layoutAlgorithm: 'squarified',
      data: categoryDistributionData.map(item => ({
        name: item.name,
        value: item.value,
        colorValue: item.value
      }))
    }],
    colorAxis: {
      minColor: '#EFEFFF',
      maxColor: '#003366'
    },
    ...getExportingOptions('Category Treemap')
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default CategoryTreemap;
